export function createPdfDownloadUrl({ path, url }) {
  return `/pdf${path}?` + new URLSearchParams([["fileUrl", url]]);
}

export function createVimeoMetadataUrl({ vimeoId, path }) {
  return path + "?" + new URLSearchParams([["vimeoId", vimeoId]]);
}
